export default "__VITE_ASSET__BQCkkLFB__"